
export function displayState(state:string|undefined)
{
	const states:Record<string,string> = {act:'ACT',nsw:'NSW',nt:'NT',qld:'Qld',sa:'SA',tas:'Tas',vic:'Vic',wa:'WA'};
	return state==undefined ? undefined : states[state];
}

